import {Injectable} from '@angular/core';
import {moduloConciliacionBan} from '../../diccionarios/conciliacionBancariaModulo';
import {CommonService} from 'src/app/shared/utils/common.service';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {ReglaOpBanca} from '../../models/conciliacionbancaria/reglaOpBanca';


@Injectable({
  providedIn: 'root'
})
export class ReglasOperacionBancariaService {

  // params: any;
  diccionarioUrl: any;
  urlFinanzas: string;
  paramFeriados: any;

  // urlDatosMaestros: string;

  constructor(private _commom: CommonService,
              private _util: UtilsService) {
    this.diccionarioUrl = moduloConciliacionBan.url.conciliacionBancaria;
    // this.urlDatosMaestros = this._util.getDatosMaestros();
    this.urlFinanzas = this._util.getFinanciero('');
    // this.params = moduloConciliacionBan.url.parametros;
    this.paramFeriados = moduloConciliacionBan.url.configuracionFeriados;
  }

  getAll() {
    return this._commom.peticionGetConHeader(this.urlFinanzas + this.diccionarioUrl.reglasBanca);
  }

  find(idParam: number) {
    return this._commom.peticionGetConHeader(this.urlFinanzas + this.diccionarioUrl.reglasBanca + '/' + idParam);
  }

  actualizar(inObjeto: ReglaOpBanca) {
    return this._commom.peticionPutConHeader(this.urlFinanzas + this.diccionarioUrl.reglasBanca, inObjeto);
  }

  guardarParametros(inObjeto: ReglaOpBanca) {
    return this._commom.peticionPostConHeader(this.urlFinanzas + this.diccionarioUrl.reglasBanca, inObjeto);
  }

  deteleParametros(idParam: number) {
    return this._commom.peticionDeleteConHeader(this.urlFinanzas + this.diccionarioUrl.reglasBanca + '/' + idParam);
  }

  /**Parametros de feriado */
  getAllParamFeriados() {
    return this._commom.peticionGetConHeader(this.urlFinanzas +"/conci-banc/"+ this.paramFeriados.crud);
  }

  findParamFeriados(idParam: number) {
    return this._commom.peticionGetConHeader(this.urlFinanzas +"/conci-banc/"+ this.paramFeriados.crud + '/' + idParam);
  }

  actualizarParamFeriados(inObjeto: ReglaOpBanca) {
    return this._commom.peticionPutConHeader(this.urlFinanzas +"/conci-banc/"+ this.paramFeriados.crud, inObjeto);
  }

  guardarParametrosParamFeriados(inObjeto: ReglaOpBanca) {
    return this._commom.peticionPostConHeader(this.urlFinanzas +"/conci-banc/"+ this.paramFeriados.crud, inObjeto);
  }

  deteleParametrosParamFeriados(idParam: number) {
    return this._commom.peticionDeleteConHeader(this.urlFinanzas +"/conci-banc/"+ this.paramFeriados.crud + '/' + idParam);
  }


}
